import Profile from './Components/Javascript/profile'
import React from 'react'

export default function dashboard() {
  return (
    <div>
      <Profile />
    </div>
  )
}
